import { useQuery } from "@tanstack/react-query";
import { getCommentsReportReasons } from "../services/commentsReportReasons.service";
import { CommentsReportReasons } from "../types/commentsReportReasons.types";

export const useCommentsReportReasons = () => {
  return useQuery<CommentsReportReasons.ReportReason[]>({
    queryKey: ["lists", "commentsReportReasons"],
    queryFn: getCommentsReportReasons,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
